import { render, staticRenderFns } from "./SurfaceDesignColorsNew.vue?vue&type=template&id=865ddb5a"
import script from "./SurfaceDesignColorsNew.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignColorsNew.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignColorsNew.vue?vue&type=style&index=0&id=865ddb5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports